"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Rating;

require("core-js/modules/es.parse-float.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _RatingModule = _interopRequireDefault(require("../../assets/styles/components/Rating.module.scss"));

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Rating(_ref) {
  let {
    value = 3,
    count = 5,
    onChange,
    disabled,
    size = "default",
    symbol = "\u2605",
    isClearable = false,
    children,
    gap = ".3rem"
  } = _ref;
  (0, _react.useEffect)(() => {
    if (!isNaN(value)) {
      setRating(parseFloat(value));
    }
  }, [value]);
  const [rating, setRating] = (0, _react.useState)(0);
  const [hover, setHover] = (0, _react.useState)(0);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "\n                ".concat(_RatingModule.default.star_group, " \n                ").concat(size === "mini" ? _RatingModule.default.size_mini : size === "compact" ? _RatingModule.default.size_compact : size === "default" ? _RatingModule.default.size_default : size === "large" ? _RatingModule.default.size_large : _RatingModule.default.size_default, "\n            "),
    style: {
      gap: gap
    },
    children: [...Array(parseFloat(count))].map((star, index) => {
      index += 1;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        disabled: disabled,
        type: "button",
        className: index <= (hover || rating) ? _RatingModule.default.on : _RatingModule.default.off,
        onClick: () => {
          if (index === rating && isClearable) {
            setRating(0);
            setHover(0);
          } else {
            onChange(index);
            setRating(index);
          }
        },
        onMouseEnter: () => setHover(index),
        onMouseLeave: () => setHover(rating),
        onDoubleClick: () => {
          if (isClearable) {
            setRating(0);
            setHover(0);
          }
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _RatingModule.default.star,
          children: children ? children : symbol
        })
      }, index);
    })
  });
}